function o(e) {
  const n = /([A-Za-z_][A-Za-z_0-9]*)?/, t = {
    scope: "params",
    begin: /\(/,
    end: /\)(?=\:?)/,
    endsParent: !0,
    relevance: 7,
    contains: [
      {
        scope: "string",
        begin: '"',
        end: '"'
      },
      {
        scope: "keyword",
        match: [
          "true",
          "false",
          "in"
        ].join("|")
      },
      {
        scope: "variable",
        match: /[A-Za-z_][A-Za-z_0-9]*/
      },
      {
        scope: "operator",
        match: /\+|\-|\*|\/|\%|\=\=|\=|\!|\>|\<|\&\&|\|\|/
      }
    ]
  }, a = {
    match: [
      n,
      /(?=\()/
    ],
    scope: {
      1: "keyword"
    },
    contains: [t]
  };
  return t.contains.unshift(a), {
    name: "Leaf",
    contains: [
      // #ident():
      {
        match: [
          /#+/,
          n,
          /(?=\()/
        ],
        scope: {
          1: "punctuation",
          2: "keyword"
        },
        // will start up after the ending `)` match from line ~44
        // just to grab the trailing `:` if we can match it
        starts: {
          contains: [
            {
              match: /\:/,
              scope: "punctuation"
            }
          ]
        },
        contains: [
          t
        ]
      },
      // #ident or #ident:
      {
        match: [
          /#+/,
          n,
          /:?/
        ],
        scope: {
          1: "punctuation",
          2: "keyword",
          3: "punctuation"
        }
      }
    ]
  };
}
export {
  o as default
};
